export const LAYOUT_MAX_BOXES_COUNT = 18;
export const REFETCH_TIME_INTERVAL = 30 * 1000;
export const VIDEOPLAYER_REINIT_ERROR_DELAYS = [0, 5, 30];
export const VIDEO_PROFILE = ['webrtc-320x180', 'webrtc-640x360', 'webrtc-1280x720p'];
